import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, filter, Observable, take } from 'rxjs';
import { AuthenticateUserState } from '../../core/store/authenticate-user.state';
import { TopNavigationService } from '../../core/services/top-navigation.service';
import { DASHBOARD_ROUTE, REDIRECT_INSPECTION } from '../../shared/constants';
import { Router } from '@angular/router';
import { LevelNameService } from '../../core/services/level-name.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  public isLoading = false;
  defaultLoad = true;
  isAuthenticated$: Observable<boolean | null | undefined> | undefined;
  storePrimaryCompanyID$: Observable<string | null> | undefined;
  storePrimaryCompnayId: string | null = '';
  handled = false;
  constructor(
    private router: Router,
    private store: Store,
    private levelNameService: LevelNameService,
    private topNavigationService: TopNavigationService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.isAuthenticated$ = this.store.select(
      AuthenticateUserState.getIsAuthenticated,
    );
    this.storePrimaryCompanyID$ = this.store.select(
      AuthenticateUserState.getSyrcPrimaryCompanyId,
    );
    combineLatest([
      this.topNavigationService.sidebarApiCallCompleted$,
      this.store.select(AuthenticateUserState.getSyrcPrimaryCompanyId),
    ])
      .pipe(
        filter(
          ([sidebarCompleted, primaryCompanyId]) =>
            !!sidebarCompleted && !!primaryCompanyId,
        ),
        take(1),
      )
      .subscribe(([, primaryCompanyId]) => {
        this.storePrimaryCompnayId = primaryCompanyId;
        this.checkandSetLevelName();
      });
  }

  async checkandSetLevelName() {
    await this.levelNameService.generateLevelNames();
    if (this.isLoading) {
      this.isLoading = false;
    }
 
    if (this.router.url.split(/[?#]/)[0] === `/${DASHBOARD_ROUTE}`) {
      this.router.navigate([REDIRECT_INSPECTION]);
    }
  }
}
